<template>
   <div class="sz-lists-roll" :style="{ width: width }">
      <div class="roll__wrap">
         <div
            class="roll__wrap-row"
            v-for="row in list"
            :class="[
               modelValue == row[prop.id] ? 'roll__wrap-row--active' : null,
            ]"
            :key="row[prop.id]"
            @click="rowClick(row)"
         >
            <div class="wrap-row__content">{{ row[prop.label] }}</div>
         </div>
      </div>
   </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
   emits: ["update:modelValue"],
   props: {
      /**
       * @param {Array} list 数据列表
       */
      list: {
         type: Array as PropType<any[]>,
         default: (): any[] => [],
      },

      /**
       * @param {Object} prop 可选参数
       */
      prop: {
         type: Object as PropType<any>,
         default: (): any => {
            return {
               label: "label",
               id: "id",
            };
         },
      },

      /**
       *@param {String, Number]} width 列表宽度
       */
      width: {
         type: [String, Number],
         default: "279px",
      },

      /**
       * 选中值
       */
      modelValue: {
         type: [String, Number],
         default: "",
      },
   },
   setup(props, context) {
      const rowClick = (row: any) => {
         context.emit("update:modelValue", row[props.prop.id]);
      };
      return {
         rowClick,
      };
   },
});
</script>
<style lang='less' scoped>
.sz-lists-roll {
   overflow-y: scroll;
   height: 100%;
   .roll__wrap {
      height: 40px;
      line-height: 40px;
      position: relative;
      &-row {
         padding-left: 10px;
         cursor: pointer;
         .wrap-row__content {
            height: 40px;
            width: calc(100% - 20px);
            display: -webkit-box;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
         }
      }
      &-row--active {
         border-right: 4px solid #19c2bd;
         background-color: #f7fffe;
         color: #19c2bd;
         font-weight: bold;
         transition: color 0.2s, background-color 0.2s;
      }
   }
}
</style>